<template>
  <div class="agent-team">
    <div class="team-header">
      <div class="search-bar">
        <input type="text" v-model="searchUsername" :placeholder="$t('Search username')" @keyup.enter="searchTeam">
        <button class="search-btn" @click="searchTeam">{{ $t('Search') }}</button>
      </div>
    </div>

    <div class="team-stats">
      <div class="stat-item">
        <div class="stat-value">{{ stats.l1_count }}</div>
        <div class="stat-label">{{ $t('Direct Count') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.l2_count }}</div>
        <div class="stat-label">{{ $t('Second Count') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.l3_count }}</div>
        <div class="stat-label">{{ $t('Third Count') }}</div>
      </div>
    </div>

    <div class="member-list">
      <div class="member-item" v-for="member in members" :key="member.id">
        <div class="member-name">{{ member.username }}</div>
        <div class="member-detail">
          <span>{{ $t('Downline Level') }}: {{ member.level }}</span>
          <span>{{ $t('Is Agent') }}: {{ member.isagent ? $t('Yes') : $t('No') }}</span>
          <span>{{ $t('Loss Amount') }}: {{ member.loss_amount | vnd }}</span>
        </div>
      </div>
      <div class="no-data" v-if="members.length === 0">{{ $t('No team members yet') }}</div>
    </div>

    <div class="pagination" v-if="totalPages > 1">
      <button class="page-btn" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">{{ $t('Previous Page') }}</button>
      <span class="page-info">{{ $t('Page') }} {{ currentPage }} / {{ totalPages }}</span>
      <button class="page-btn" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">{{ $t('Next Page') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agentTeam',
  data() {
    return {
      searchUsername: '',
      stats: { l1_count: 0, l2_count: 0, l3_count: 0 },
      members: [],
      currentPage: 1,
      totalPages: 1,
    };
  },
  created() {
    this.getTeamMembers();
  },
  methods: {
    searchTeam() {
      this.currentPage = 1;
      this.getTeamMembers();
    },
    getTeamMembers() {
      const params = {
        page: this.currentPage,
        username: this.searchUsername,
      };
      this.$apiFun.get('/api/agent/team', params).then((res) => {
        if (res && res.code === 200 && res.data) {
          this.members = res.data.list || [];
          this.totalPages = res.data.last_page || 1;
          this.stats = {
            l1_count: res.data.l1_count || 0,
            l2_count: res.data.l2_count || 0,
            l3_count: res.data.l3_count || 0,
          };
        }
      }).catch(() => {
        this.members = [];
      });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getTeamMembers();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-team {
  padding: 16px;
  color: #352b24;
}

.search-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;

  input {
    flex: 1;
    height: 40px;
    border: 1px solid #ead1b2;
    border-radius: 8px;
    padding: 0 10px;
    background: #fff8ef;
  }

  .search-btn {
    padding: 0 14px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, #ffe082 0%, #d1a03e 50%, #b8860b 100%);
    color: #4a2e00;
    font-weight: 700;
  }
}

.team-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 14px;
}

.stat-item {
  background: #fff8ef;
  border: 1px solid #ead1b2;
  border-radius: 12px;
  padding: 12px 6px;
  text-align: center;
}

.stat-value {
  font-size: 18px;
  font-weight: 800;
  color: #8f501f;
}

.stat-label {
  font-size: 12px;
  color: #8a6a4a;
  margin-top: 4px;
}

.member-item {
  background: #fff;
  border: 1px solid #eadfd3;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 10px;
}

.member-name {
  font-weight: 700;
  margin-bottom: 8px;
}

.member-detail {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  font-size: 12px;
  color: #8a6a4a;
}

.no-data {
  text-align: center;
  color: #8a6a4a;
  padding: 28px 12px;
  background: #fff8ef;
  border: 1px dashed #ead1b2;
  border-radius: 12px;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 12px;
}

.page-btn {
  border: 1px solid #d9b98f;
  background: #fff8ef;
  color: #8f501f;
  border-radius: 8px;
  padding: 6px 10px;
}

.page-info {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/agent/agentTeam.vue